import { cellToBoundary } from 'h3-js'
import { Layer, Source } from 'react-map-gl'
import { useStoreContext } from '#app/store'

export const PlotsFetched = () => {
	const fetchedPlotIds = useStoreContext(s => s.fetchedPlotIds)

	return (
		<>
			{fetchedPlotIds.map(({ plotId }) => {
				const coordinates = cellToBoundary(plotId, true)

				return (
					<Source
						key={`owned-${plotId}`}
						type="geojson"
						data={{
							type: 'FeatureCollection',
							features: [
								{
									type: 'Feature',
									geometry: {
										type: 'Polygon',
										coordinates: [coordinates],
									},
									id: plotId,
									properties: {},
								},
							],
						}}
					>
						<Layer
							{...{
								id: `${plotId}-fill-layer`,
								type: 'fill',
								paint: {
									'fill-color': 'red',
									'fill-opacity': 0.1,
								},
							}}
						/>
						<Layer
							{...{
								id: `${plotId}-line-layer`,
								type: 'line',
								paint: {
									'line-color': 'red', //amber 400 and purple 400
									'line-width': 1,
								},
							}}
						/>
					</Source>
				)
			})}
		</>
	)
}
